import { render, staticRenderFns } from "./CardStyle6.vue?vue&type=template&id=cffd240c&scoped=true&"
import script from "./CardStyle6.vue?vue&type=script&lang=js&"
export * from "./CardStyle6.vue?vue&type=script&lang=js&"
import style0 from "./CardStyle6.vue?vue&type=style&index=0&id=cffd240c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffd240c",
  null
  
)

export default component.exports